import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const TestResultsContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
  font-family: 'Noto Sans Thai', sans-serif !important;
  * {
    font-family: 'Noto Sans Thai', sans-serif !important;
    font-weight: normal;
    color: #666666;
  }
`;

const MainHeader = styled.div`
  background: white;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Logo = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

const HeaderTitle = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #666;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const ProfileImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

const NotificationContainer = styled.div`
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease;
  margin-right: 8px;

  &:hover {
    transform: scale(1.1);
  }
`;

const BellIcon = styled.div`
  width: 20px;
  height: 20px;
  background-image: url("data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' fill='%23666666'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

const NotificationBadge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: #ff4444;
  color: white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Sans Thai', sans-serif !important;
  min-width: 16px;
  padding: 0 2px;
`;

const ProfileName = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #666;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const TabContainer = styled.div`
  display: flex;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e1e5e9;
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
`;

const Tab = styled.div`
  padding: 12px 5px;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
  color: ${props => props.active ? 'white' : '#B0B0B0'};
  background-color: ${props => props.active ? '#00BBD3' : '#F2F2F2'};
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Noto Sans Thai', sans-serif !important;
  line-height: 1.2;
  white-space: nowrap;
  
  ${props => {
    if (props.children === 'สุขภาพของคุณ') {
      return `width: 152px;`;
    } else if (props.children === 'ผลตรวจรวม') {
      return `width: 120px;`;
    } else if (props.children === 'ผลตรวจเปรียบเทียบ') {
      return `width: 168px;`;
    }
    return '';
  }}
  
  &:hover {
    background-color: ${props => props.active ? '#00BBD3' : '#e9ecef'};
  }
`;

const Content = styled.div`
  padding: 24px;
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const ResultCard = styled.div`
  background-color: white;
  border-radius: 5px 5px 0 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;

const CardHeader = styled.div`
  background-color: #00BBD3;
  padding: 16px 20px;
  color: white;
  text-align: center;
`;

const HeaderText = styled.h3`
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  color: white;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const SectionTitle = styled.h4`
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  margin: 20px 0 12px 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const CardContainer = styled.div`
  margin-bottom: 24px;
`;

const DownloadContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
`;

const DownloadButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 25px;
  font-weight: 700;
  color: #666666;
  font-family: 'Noto Sans Thai', sans-serif !important;
  padding: 8px 12px;

  &:hover {
    color: #00BBD3;
  }
`;

const PDFIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
`;

const CardContent = styled.div`
  padding: 20px;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const InfoLabel = styled.span`
  font-size: 16px;
  color: #666666;
  font-family: 'Noto Sans Thai', sans-serif !important;
  padding-left: ${props => props.indent ? '24px' : '0'};
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
`;

const InfoValue = styled.span`
  font-size: 16px;
  color: #666666;
  font-family: 'Noto Sans Thai', sans-serif !important;
  font-weight: bold;
`;

const Divider = styled.hr`
  border: none;
  height: 1px;
  background-color: #e1e5e9;
  margin: 16px 0;
`;

const TestResultsPage = () => {
  const navigate = useNavigate();
  const [notificationCount, setNotificationCount] = useState(3);

  const handleNotificationClick = () => {
    navigate('/notifications');
  };

  const handleDownload = (reportDate) => {
    console.log(`Download PDF for ${reportDate}`);
  };

  const handleTabClick = (tab) => {
    if (tab === 'สุขภาพของคุณ') {
      window.location.href = '/dashboard'; // หรือใช้ navigate('/dashboard')
    } else if (tab === 'ผลตรวจเปรียบเทียบ') {
      window.location.href = '/comparison-results'; // หรือใช้ navigate('/comparison-results')
    }
  };

  return (
    <TestResultsContainer>
      <MainHeader>
        <HeaderLeft>
          <Logo src="./logo.png" alt="MFU Logo" />
          <HeaderTitle>MFU Wellness Center</HeaderTitle>
        </HeaderLeft>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <NotificationContainer onClick={handleNotificationClick}>
            <BellIcon />
            {notificationCount > 0 && (
              <NotificationBadge>{notificationCount}</NotificationBadge>
            )}
          </NotificationContainer>
          <ProfileContainer onClick={() => navigate('/profile-edit')}>
            <ProfileName>พงษ์ชัย</ProfileName>
            <ProfileImage src="./person.png" alt="Profile" />
          </ProfileContainer>
        </div>
      </MainHeader>

      <TabContainer>
        <Tab onClick={() => handleTabClick('สุขภาพของคุณ')}>สุขภาพของคุณ</Tab>
        <Tab active>ผลตรวจรวม</Tab>
        <Tab onClick={() => handleTabClick('ผลตรวจเปรียบเทียบ')}>ผลตรวจเปรียบเทียบ</Tab>
      </TabContainer>

      <Content>
        <CardContainer>
          <DownloadContainer>
            <DownloadButton onClick={() => handleDownload('23/12/24')}>
              <span>Download</span>
              <PDFIcon src="./PDF.png" alt="PDF" />
            </DownloadButton>
          </DownloadContainer>

          <ResultCard>
            <CardHeader>
              <HeaderText>ผลตรวจ</HeaderText>
            </CardHeader>
            
            <CardContent>
              <InfoRow>
                <InfoLabel bold>วันที่ตรวจ</InfoLabel>
                <InfoValue>23/12/24</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel bold>ตรวจที่</InfoLabel>
                <InfoValue>โรงพยาบาล</InfoValue>
              </InfoRow>

              <Divider />

              <SectionTitle>รายการตรวจ</SectionTitle>
              <InfoRow>
                <InfoLabel>ความดันโลหิต</InfoLabel>
                <InfoValue>120 / 80</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel>น้ำตาลในเลือด</InfoLabel>
                <InfoValue>167</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel>ไขมัน</InfoLabel>
                <InfoValue></InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel indent>คอเลสเตอรอลรวม</InfoLabel>
                <InfoValue>120</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel indent>ไตรกลีเซอไรด์</InfoLabel>
                <InfoValue>120</InfoValue>
              </InfoRow>

              <InfoRow>
                <InfoLabel>ตับ</InfoLabel>
                <InfoValue>120</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel>ไต</InfoLabel>
                <InfoValue>120</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel>กรดยูริค</InfoLabel>
                <InfoValue>120</InfoValue>
              </InfoRow>
            </CardContent>
          </ResultCard>
        </CardContainer>

        <CardContainer>
          <DownloadContainer>
            <DownloadButton onClick={() => handleDownload('13/6/23')}>
              <span>Download</span>
              <PDFIcon src="./PDF.png" alt="PDF" />
            </DownloadButton>
          </DownloadContainer>

          <ResultCard>
            <CardHeader>
              <HeaderText>ผลตรวจ</HeaderText>
            </CardHeader>
            
            <CardContent>
              <InfoRow>
                <InfoLabel bold>วันที่ตรวจ</InfoLabel>
                <InfoValue>13/6/23</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel bold>ตรวจที่</InfoLabel>
                <InfoValue>โรงพยาบาล</InfoValue>
              </InfoRow>

              <Divider />

              <SectionTitle>รายการตรวจ</SectionTitle>
              <InfoRow>
                <InfoLabel>ความดันโลหิต</InfoLabel>
                <InfoValue>120 / 80</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel>น้ำตาลในเลือด</InfoLabel>
                <InfoValue>167</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel>ไขมัน</InfoLabel>
                <InfoValue></InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel indent>คอเลสเตอรอลรวม</InfoLabel>
                <InfoValue>120</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel indent>ไตรกลีเซอไรด์</InfoLabel>
                <InfoValue>120</InfoValue>
              </InfoRow>

              <InfoRow>
                <InfoLabel>ตับ</InfoLabel>
                <InfoValue>120</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel>ไต</InfoLabel>
                <InfoValue>120</InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel>กรดยูริค</InfoLabel>
                <InfoValue>120</InfoValue>
              </InfoRow>
            </CardContent>
          </ResultCard>
        </CardContainer>
      </Content>
    </TestResultsContainer>
  );
};

export default TestResultsPage;